import { Swiper } from 'swiper';
import { A11y, Navigation, Autoplay, EffectFade } from 'swiper/modules';

const sliders = document.querySelectorAll(
	'.acf-block:not(.block-testimonial-cards) .block-testimonials .swiper'
);

if (sliders.length > 0) {
	sliders.forEach((slider, index) => {
		slider.parentElement.classList.add(
			`block-testimonials__swiper--${index}`
		);
		const tabs = slider.parentElement.querySelectorAll(
			'.swiper-tabs button'
		);

		const settings = {
			autoplay: tabs.length > 0 ? { delay: 5000 } : false,
			loop: true,
			grabCursor: true,
			spaceBetween: 32,
			slidesPerView: 1,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			modules: [A11y, Navigation, Autoplay, EffectFade],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: `.block-testimonials__swiper--${index} .swiper-button-prev`,
				nextEl: `.block-testimonials__swiper--${index} .swiper-button-next`,
			},
		};

		const swiper = new Swiper(slider, settings);

		if (tabs.length > 0) {
			swiper.on('realIndexChange', (swiperObj) => {
				tabs.forEach((tab, tabIndex) => {
					if (tabIndex === swiperObj.realIndex) {
						tab.classList.add('active');
					} else {
						tab.classList.remove('active');
					}
				});
			});

			tabs.forEach((tab, i) => {
				tab.addEventListener('click', () => swiper.slideToLoop(i));
			});
		}
	});
}
